import { render, staticRenderFns } from "./InRoot.vue?vue&type=template&id=5df8467e&scoped=true&lang=pug"
import script from "./InRoot.vue?vue&type=script&lang=js"
export * from "./InRoot.vue?vue&type=script&lang=js"
import style0 from "./InRoot.vue?vue&type=style&index=0&id=5df8467e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8467e",
  null
  
)

export default component.exports